/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocalBarIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-local-bar"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.68 18.95L10.68 14.75L2.58 5.6Q2.33 5.33 2.2 4.99Q2.08 4.65 2.08 4.3Q2.08 3.48 2.66 2.89Q3.25 2.3 4.08 2.3L19.93 2.3Q20.75 2.3 21.34 2.89Q21.93 3.48 21.93 4.3Q21.93 4.65 21.8 4.99Q21.68 5.33 21.43 5.6L13.32 14.75L13.32 18.95L17.4 18.95Q17.95 18.95 18.34 19.34Q18.73 19.73 18.73 20.27Q18.73 20.82 18.34 21.21Q17.95 21.6 17.4 21.6L6.6 21.6Q6.05 21.6 5.66 21.21Q5.28 20.82 5.28 20.27Q5.28 19.73 5.66 19.34Q6.05 18.95 6.6 18.95ZM7.35 7L16.65 7L18.5 4.95L5.5 4.95Z" fill={color} />
    </svg>
  );
}
